export default __webpack_public_path__ + "static/828-f50cb19997a1a83659a7cbbd2cf23bd1.png";